import { applyUpdate } from '../utils/pwaUpdate';

/**
 * "בדיקת עדכונים" (M3, T-30): an item in the avatar menu and the "עוד" sheet
 * (it was a permanent top-bar icon). Same behaviour: clear caches, unregister
 * Service Workers and reload onto the latest build (`applyUpdate`).
 */
let busy = false;

export function runUpdateCheck(): void {
  if (busy) return;
  busy = true;
  void applyUpdate().finally(() => {
    // applyUpdate reloads the page, so this usually never runs.
    busy = false;
  });
}
